import { RQ_PARAMETERS } from '@brighterion/utils/react-query-constants';
import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { deleteParameter } from 'Services';

type Props = {
    mutationOptions: UseMutationOptions<AxiosResponse<Parameter[]>, unknown, DeleteParameRequest, unknown>;
};

const useDeleteParameter = ({ mutationOptions }: Props) => {
    const queryClient = useQueryClient();

    return useMutation(deleteParameter, {
        onSuccess: mutationOptions.onSuccess,
        onError: mutationOptions.onError,
        onSettled: () => {
            queryClient.invalidateQueries([RQ_PARAMETERS]);
        }
    });
};

export default useDeleteParameter;
